export enum FinalizationSteps {
    Start,
    CreateHosting,
    WaitingForAllTrialHostingInfoSchedule,
    AllTrialHostingInfoScheduled,
    AddingTrialHostingInfo,
    HostingCreatedWithAllInfo,
    ApiDataSaved,
    AfterSaveActionsDone,
    CreateLocalDatabase,
    Finish,
    Error,
    DuplicateEmailRequestError
}

const TERMINAL_FINALIZATION_STEPS = [FinalizationSteps.Finish, FinalizationSteps.Error, FinalizationSteps.DuplicateEmailRequestError];

export const isTerminalFinalizationStep = (finalizationStep: FinalizationSteps) => {
    return TERMINAL_FINALIZATION_STEPS.includes(finalizationStep);
};